module.exports = function (metaValues) {
    var metadata = {};
    metaValues.forEach(function (value) {
        var type = value.$attr('type'),
            declId = value.$attr('decl-id'),
            val = value.$text();
        if (Array.isArray(val)) {
            val = val.join('');
        }
        val = val.trim();
        switch (type) {
            case 'boolean':
                val = !!+val;
                break;
            case 'integer':
                val = +val;
                break;
            case 'string':
                break;
            case 'string_array':
                val = value.$('valueItem').map(function (v) { return v.$text().trim(); });
                break;
            case 'integer_array':
                val = value.$('valueItem').map(function (v) { return +v.$text(); });
                break;
            default:
                if (/^(Yes|No)$/.test(val)) {
                    val = (val == 'Yes');
                }
        }
        metadata[declId] = val;
    });
    return metadata;
};